export const ORDERS_ACTIONS = {
  SET_ORDER: "SET_ORDER",
  SET_ORDERS: "SET_ORDERS",
  GET_ORDERS: "GET_ORDERS",
  SET_ORDERS_STATUS: "SET_ORDERS_STATUS",
};
